export default __webpack_public_path__ + "static/lunar-celebrations-lanterns-11e348e404dc6ff6a8dd91fb4049c340.jpg";